import type { FaireProductEntity } from "../../entity_types/product";

export const p_yv2xtbwhdz: FaireProductEntity = {
  token: "p_yv2xtbwhdz",
  type: "product",
  name: "Peanut Fluffy Slime Filled Squishy Stress Relief Toy",
  brandToken: "b_1e67dn411w",
  brandName: "Cap Zone",
  imageUrl:
    "https://cdn.faire.com/fastly/bf244879b47cf9fcf13ed7474c141ec76882101bf691bb3888c6d062b852e425.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cc1b295671074d8d7eeb4d8faf368731d7f41fd0eaf58f7b5227cffc4aecd16.jpeg",
    "https://cdn.faire.com/fastly/6bd258a9379d19a4f36e671c255db90d32a0bd6b0455e3b5a0cf6738bc9e612b.jpeg",
    "https://cdn.faire.com/fastly/165f6be82b7f487053dc02def06fe7187726d2907eab0b63a711530cf9c64558.jpeg",
    "https://cdn.faire.com/fastly/2392295a31b3d611ae45e2a3c9e9ed4a178e3fc629dc758ddc592308c1d3d651.jpeg",
    "https://cdn.faire.com/fastly/8d30f79e39968f71b9b54d31c4b8c39ae1df5e852c4d583e84a4ddeff5224e69.jpeg",
    "https://cdn.faire.com/fastly/a9ab8e9ccb4894f287a010cc18fe40af74c18c9cf5b1c0542816b2491489a79b.jpeg",
  ],
  priceDollars: 2.5,
  description:
    'Peanut Fluffy Slime Filled Soft TPR Squishy Stress Relief Toy\r\n\r\n-Squishy Dimensions: Appx. 2" * 2" * 4"\r\n-Display Box Dimensions: Appx. 12.5" * 9" * 2"\r\n-CA Prop 65 Advisory\r\n\r\n-Features: Soft stretchable fluffy slime filled realistic peanut squishy\r\n\r\n-Packaging Details: Individually packaged in clear plastic bag. Packaged as a whole in illustrated carton display box. ',
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:45.131Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
